module.exports = __webpack_public_path__ + "static/media/quiz.ab00980c.mp3";